<template>
  <div class="lib__form__fieldset-group">
    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">
        {{ $t('prosumerBonus.personalInfo.accountSection') }}
        <sup class="lib__tooltips lib__tooltips--large" style="margin-left: 5px">
          <span class="lib__tooltips__trigger">
            <i class="fas fa-info"></i>
          </span>
          <span class="lib__tooltips__data">{{ $t('prosumerBonus.personalInfo.accountSectionTooltip') }}</span>
        </sup>
      </legend>

      <div class="row">
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('prosumerBonus.personalInfo.iban')" iban required v-model="value.bankAccountIban"></text-box>
        </div>
        <div class="col-xs-12 col-md-6" v-if="bicVisible">
          <masked-text-box :label="$t('prosumerBonus.personalInfo.bic')" mask="XXXXXXXXXXX" pattern="([A-Z,a-z,0-9]{8,11})" required v-model="value.bankAccountBic"></masked-text-box>
        </div>
      </div>
    </fieldset>

    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">
        {{ $t('prosumerBonus.personalInfo.contactSection') }}
        <sup class="lib__tooltips lib__tooltips--large" style="margin-left: 5px">
          <span class="lib__tooltips__trigger">
            <i class="fas fa-info"></i>
          </span>
          <span class="lib__tooltips__data">{{ $t('prosumerBonus.personalInfo.contactSectionTooltip') }}</span>
        </sup>
      </legend>

      <div class="row">
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('prosumerBonus.personalInfo.email')" email required v-model="value.email"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <phone-box :label="$t('prosumerBonus.personalInfo.mobile')" gsm v-model="value.phone"></phone-box>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { PersonalInfo } from '@/models'

@Component
export default class PersonalInfoForm extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly value!: PersonalInfo
  //#endregion

  //#region [Computed]
  public get bicVisible(): boolean {
    return (
      this.value.bankAccountIban !== null &&
      this.value.bankAccountIban.length > 1 &&
      !this.value.bankAccountIban.toLowerCase().startsWith('be')
    )
  }
  //#endregion
}
</script>